import { AxiosResponse } from 'axios';
import { SET_API_KEYS, SET_API_KEY, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_API_KEY_ISLOADING,
  DELETE_API_KEY,
  EDIT_API_KEY,
  GET_API_KEYS,
  REGISTER_API_KEY,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import APIKey from '@/services/api_key';
import { Module } from 'vuex';
import { EditAPIKey, RegisterAPIKey, GetAPIKey } from '@/dtos/api_key.dto';

const apiKey: Module<any, {}> = {
  state: {
    apiKey: {
      data: null,
      isLoading: false,
    },
    apiKeys: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    apiKey: (state: { apiKey: any }) => state.apiKey,
    apiKeys: (state: { apiKeys: any }) => state.apiKeys,
  },
  mutations: {
    [SET_API_KEY]: (
      state: { apiKey: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.apiKey.data = payload.data) : null,
        (state.apiKey.isLoading = payload.isLoading);
    },
    [SET_API_KEYS]: (
      state: { apiKeys: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.apiKeys.data = payload.data) : null,
        (state.apiKeys.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_API_KEY]: async ({ commit }: any, payload: any) => {
      commit(SET_API_KEY, { data: null, isLoading: true });

      const result: AxiosResponse = await APIKey.registerAPIKey(
        payload as RegisterAPIKey
      );

      if (result) {
        if (result.data.status) {
          commit(SET_API_KEY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_API_KEY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_API_KEY, { isLoading: false });
        return false;
      }
    },
    [GET_API_KEYS]: async ({ commit }: any, payload: any) => {
      commit(SET_API_KEYS, { data: null, isLoading: true });

      const result: AxiosResponse = await APIKey.getAPIKeys(
        payload as GetAPIKey
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_API_KEYS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_API_KEYS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_API_KEYS, { isLoading: false });
        return false;
      }
    },
    [EDIT_API_KEY]: async ({ commit }: any, payload: any) => {
      commit(SET_API_KEY, { data: null, isLoading: true });

      const result: AxiosResponse = await APIKey.editAPIKey(
        payload as EditAPIKey
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_API_KEY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_API_KEY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_API_KEY, { isLoading: false });
        return false;
      }
    },
    [DELETE_API_KEY]: async ({ commit }: any, payload: string) => {
      commit(SET_API_KEY, { data: null, isLoading: true });

      const result: AxiosResponse = await APIKey.deleteAPIKey(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_API_KEY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_API_KEY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_API_KEY, { isLoading: false });
        return false;
      }
    },
    [CLEAR_API_KEY_ISLOADING]: ({ commit }) => {
      commit(SET_API_KEY, { isLoading: false });
      commit(SET_API_KEYS, { isLoading: false });
    },
  },
};

export default apiKey;